import { render, staticRenderFns } from "./submission.vue?vue&type=template&id=bcea329e&scoped=true&"
import script from "./submission.vue?vue&type=script&lang=ts&"
export * from "./submission.vue?vue&type=script&lang=ts&"
import style0 from "./submission.vue?vue&type=style&index=0&id=bcea329e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcea329e",
  null
  
)

export default component.exports